import router from './router'

export default {
	moduleName: 'contentReview',
  router
}



// WEBPACK FOOTER //
// ./src/core/modules/contentReview/index.js